import React, { createContext, useEffect, useState } from "react";
import RouteConstants from "../../../constants/routeConstants.json";
import { useGlobalContext } from "../../../GlobalState/GlobalContext";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { userDetailsApi, getActivityLog } from "../../../api/Api";
import { handleApiError } from "../../../constants/Constants";

export const ProfileManageContext = createContext({});
export const ProfileManageContextProvider = ({ children }) => {
  const navigate = useNavigate();
  // const [currentUserDetails, setCurrentUserDetails] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState();
  const [role, setRole] = useState("");
  const [mfa, setMfa] = useState("");

  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [activityLogData, setActivityLogData] = useState([]);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);
  const [statusValue, setStatusValue] = useState();
  const [buttonText, setButtonText] = useState("");
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // To track if more data exists
  const [activitySpinner, setActivitySpinner] = useState(false);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { globalProfile, setGlobalProfile } = useGlobalContext();
  // const [rolesList, setRolesList] = useState([]);

  // const permissionAccess = JSON.parse(
  //   localStorage.getItem("permissions")
  // )?.filter((item) => {
  //   return item.feature === "67371df9534964294f80cfe4";
  // })[0];
  const roleIdentifier = JSON.parse(localStorage.getItem("roleIdentifier"));
  const isSuperAdmin = roleIdentifier === "superadmin";

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    try {
      setSpinnerStatus(true);
      const userDetails = await userDetailsApi();
      setName(userDetails?.data?.data?.profile?.name);
      setEmail(userDetails?.data?.data?.profile?.email);
      setPhoneNumber(userDetails?.data?.data?.profile?.mobile);
      setRole(userDetails?.data?.data?.profile?.role?.name);
      setProfileImageUrl(userDetails?.data?.data?.profile?.profileImage);
      setGlobalProfile(userDetails?.data?.data?.profile?.profileImage);
      setMfa(userDetails?.data?.data?.profile?.multiFactorAuthentication);
    } catch (error) {
      handleApiError(
        error,
        setStatusValue,
        setErrorPopupMessage,
        setErrorPopup,
        setButtonText
      );
    }
    setSpinnerStatus(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const fullImageUrl = profileImageUrl ? profileImageUrl : false;

  const roleToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };

  const providerValue = {
    name,
    email,
    phoneNumber,
    role,
    fullImageUrl,
    activityLogData,
    formatDate,
    formatTime,
    spinnerStatus,
    mfa,
    setMfa,
    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    roleToLogin,
    statusValue,
    setStatusValue,
    getUserDetails,
    isSuperAdmin,
    currentPage,
    hasMore,
    accordionExpanded,
    setAccordionExpanded,
  };
  return (
    <ProfileManageContext.Provider value={providerValue}>
      {children}
    </ProfileManageContext.Provider>
  );
};
